import * as React from "react";
import { Grid } from "@mui/material";

import { IXProductDetailsProps } from "../../../../utils/interfaces/containers/XProductDetails.interfaces";
import { IArticleData } from "../../../../utils/interfaces/common/XArticle.interfaces";
import { TSetUrlParamsArgs } from "../../../../hooks/useXoraia";

// TODO MAKE THIS SUSPENSE ON DEV
// const ProductDetailsPreviewGrid = React.lazy(
//   () => import("./ProductDetailsPreviewGrid")
// );
// const ProductDetailsPreviewList = React.lazy(
//   () => import("./ProductDetailsPreviewList")
// );

import ProductDetailsPreviewGrid from "./ProductDetailsPreviewGrid";

import ProductDetailsPreviewList from "./ProductDetailsPreviewList";

const ProductDetailsPreview: React.FC<
  IXProductDetailsProps & {
    article: IArticleData;
    urlParams?: TSetUrlParamsArgs;
  }
> = ({ previewMode = "grid", previewPosition = "left", article }) => {
  // TODO CHECK FOR VARIANT IMAGE HERE
  const images = article.images ?? [];

  return (
    <Grid
      item
      xs={12}
      md={previewPosition === "top" ? 12 : previewMode === "list" ? 5 : 6}
    >
      {previewMode === "grid" && (
        <ProductDetailsPreviewGrid images={images} name={article.name} />
      )}
      {previewMode === "list" && (
        <ProductDetailsPreviewList images={images} name={article.name} />
      )}
    </Grid>
  );
};

export default ProductDetailsPreview;
